<template>
    <div class="col-xs-12 col-md-9 venus-os-gui">
        <div class="venus">
            <div v-for="(device, index) in filteredDevices" :key="'device-' + index" class="cell">
                <!-- GRID METER -->
                <div
                    v-if="
                        device.idDeviceType &&
                            device.idDeviceType === DEVICE_TYPES.GRID_METER &&
                            isPropertyValid('from_to_grid')
                    "
                    class="vrm-data-block block-ac_in"
                >
                    <div class="content">
                        <div class="header header__energy_meter">
                            <div class="block-icon block-icon__blue">
                                <span class="sg-vrm-icon_149_energy_meter_16px"></span>
                            </div>
                            <span>
                                {{
                                    device.customName.length > 0
                                        ? device.customName
                                        : device.productName
                                }}
                            </span>
                            <span v-if="!isMobile" class="label label--red">
                                {{
                                    $t('dashboard.input_grid_meter', { i18nFallback: 'Grid meter' })
                                }}
                            </span>
                        </div>
                        <span v-if="isMobile" class="label label--red">
                            {{ $t('dashboard.input_grid_meter', { i18nFallback: 'Grid meter' }) }}
                        </span>
                        <div class="summary">
                            <span class="load">
                                {{ getOnlyRawValue(gridMeterData.from_to_grid) }}
                                <abbr>{{ getOnlyFormatUnit(gridMeterData.from_to_grid) }}</abbr>
                            </span>
                        </div>
                        <div class="chart">
                            <HighchartsWrapper :config="charts.dashboard.from_to_grid" />
                        </div>
                    </div>
                    <div v-if="chartHoverFromToGrid" class="details graph-labels">
                        <span>{{ chartHoverFromToGrid.label }}</span>
                        <span>{{ chartHoverFromToGrid.value }}</span>
                    </div>
                    <div v-if="showDetails && isPropertyValid('g1p')" class="details details-col">
                        <div v-if="isPropertyValid('g1p')" class="detail">
                            <span class="detail__label">L1</span>
                            <span class="detail__value">{{ gridMeterData.g1p }}</span>
                            <span class="detail__value">{{ gridMeterData.g1v }}</span>
                            <span class="detail__value">{{ gridMeterData.g1c }}</span>
                        </div>
                        <div v-if="isPropertyValid('g2p')" class="detail">
                            <span class="detail__label">L2</span>
                            <span class="detail__value">{{ gridMeterData.g2p }}</span>
                            <span class="detail__value">{{ gridMeterData.g2v }}</span>
                            <span class="detail__value">{{ gridMeterData.g2c }}</span>
                        </div>
                        <div v-if="isPropertyValid('g3p')" class="detail">
                            <span class="detail__label">L3</span>
                            <span class="detail__value">{{ gridMeterData.g3p }}</span>
                            <span class="detail__value">{{ gridMeterData.g3v }}</span>
                            <span class="detail__value">{{ gridMeterData.g3c }}</span>
                        </div>
                    </div>
                </div>
                <!-- AC METER -->
                <div
                    v-if="
                        device.idDeviceType &&
                            device.idDeviceType === DEVICE_TYPES.AC_METER &&
                            isPropertyValid('ac_meter')
                    "
                    class="vrm-data-block block-ac_loads"
                >
                    <div class="content">
                        <div class="header header__energy_meter">
                            <div class="block-icon block-icon__blue">
                                <span class="sg-vrm-icon_149_energy_meter_16px"></span>
                            </div>
                            <span>
                                {{
                                    device.customName.length > 0
                                        ? device.customName
                                        : `${device.productName} [${device.instance}]`
                                }}
                            </span>
                            <span v-if="!isMobile" class="label label--green">
                                {{ $t('dashboard.ac_meter', { i18nFallback: 'AC Meter' }) }}
                            </span>
                        </div>
                        <span v-if="isMobile" class="label label--green">
                            {{ $t('dashboard.ac_meter', { i18nFallback: 'AC Meter' }) }}
                        </span>
                        <div class="summary">
                            <span class="load">
                                {{
                                    getOnlyRawValue(
                                        acMeterData.ac_meter_per_instance[device.instance]
                                            .formattedValue,
                                    )
                                }}
                                <abbr>
                                    {{
                                        getOnlyFormatUnit(
                                            acMeterData.ac_meter_per_instance[device.instance]
                                                .formattedValue,
                                        )
                                    }}
                                </abbr>
                            </span>
                        </div>
                        <div class="chart">
                            <HighchartsWrapper
                                :config="charts.dashboard.ac_meter[device.instance]"
                            />
                        </div>
                    </div>
                    <div
                        v-if="chartHoverAcMeter && chartHoverAcMeter[String(device.instance)]"
                        class="details graph-labels"
                    >
                        <span>{{ chartHoverAcMeter[String(device.instance)].label }}</span>
                        <span>{{ chartHoverAcMeter[String(device.instance)].value }}</span>
                    </div>
                    <div v-if="showDetails && acMeterData.a1p" class="details details-col">
                        <div
                            v-if="acMeterData.a1p && acMeterData.a1p[device.instance]"
                            class="detail"
                        >
                            <span class="detail__label">L1</span>
                            <span class="detail__value">
                                {{ acMeterData.a1p[device.instance].formattedValue }}
                            </span>
                            <span class="detail__value">
                                {{ acMeterData.a1v[device.instance].formattedValue }}
                            </span>
                            <span class="detail__value">
                                {{ acMeterData.a1c[device.instance].formattedValue }}
                            </span>
                        </div>
                        <div
                            v-if="acMeterData.a2p && acMeterData.a2p[device.instance]"
                            class="detail"
                        >
                            <span class="detail__label">L2</span>
                            <span class="detail__value">
                                {{ acMeterData.a2p[device.instance].formattedValue }}
                            </span>
                            <span class="detail__value">
                                {{ acMeterData.a2v[device.instance].formattedValue }}
                            </span>
                            <span class="detail__value">
                                {{ acMeterData.a2c[device.instance].formattedValue }}
                            </span>
                        </div>
                        <div
                            v-if="acMeterData.a3p && acMeterData.a3p[device.instance]"
                            class="detail"
                        >
                            <span class="detail__label">L3</span>
                            <span class="detail__value">
                                {{ acMeterData.a3p[device.instance].formattedValue }}
                            </span>
                            <span class="detail__value">
                                {{ acMeterData.a3v[device.instance].formattedValue }}
                            </span>
                            <span class="detail__value">
                                {{ acMeterData.a3c[device.instance].formattedValue }}
                            </span>
                        </div>
                    </div>
                </div>
                <!-- PV INVERTER -->
                <div
                    v-if="
                        device.idDeviceType &&
                            device.idDeviceType === DEVICE_TYPES.PV_INVERTER &&
                            isPropertyValid('ac_in')
                    "
                    class="vrm-data-block block-ac_loads"
                >
                    <div class="content">
                        <div class="header header__energy_meter">
                            <div
                                v-if="ci.pgm && ci.pgm.rawValue === 1"
                                class="block-icon block-icon__blue"
                            >
                                <span class="sg-vrm-icon_149_energy_meter_16px"></span>
                            </div>
                            <div v-else class="block-icon block-icon__orange">
                                <span class="sg-vrm-icon_022_solar-16px"></span>
                            </div>
                            <span>
                                {{
                                    device.customName.length > 0
                                        ? device.customName
                                        : `${device.productName} [${device.instance}]`
                                }}
                            </span>
                            <span
                                v-if="!isMobile && ci.pgm && ci.pgm.rawValue === 1"
                                class="label label--orange"
                            >
                                {{ $t('dashboard.pv_inverter', { i18nFallback: 'PV Inverter' }) }}
                            </span>
                        </div>
                        <span
                            v-if="isMobile && ci.pgm && ci.pgm.rawValue === 1"
                            class="label label--orange"
                        >
                            {{ $t('dashboard.pv_inverter', { i18nFallback: 'PV Inverter' }) }}
                        </span>
                        <div class="summary">
                            <span class="load">
                                {{
                                    getOnlyRawValue(
                                        pvInverterData.ac_in_per_instance[device.instance]
                                            .formattedValue,
                                    )
                                }}
                                <abbr>
                                    {{
                                        getOnlyFormatUnit(
                                            pvInverterData.ac_in_per_instance[device.instance]
                                                .formattedValue,
                                        )
                                    }}
                                </abbr>
                            </span>
                        </div>
                        <div class="chart">
                            <HighchartsWrapper
                                :config="charts.dashboard.pv_inverter[device.instance]"
                            />
                        </div>
                    </div>
                    <div
                        v-if="chartHoverPvInverter && chartHoverPvInverter[String(device.instance)]"
                        class="details graph-labels"
                    >
                        <span>{{ chartHoverPvInverter[String(device.instance)].label }}</span>
                        <span>{{ chartHoverPvInverter[String(device.instance)].value }}</span>
                    </div>
                    <div v-if="showDetails && pvInverterData.pP1" class="details details-col">
                        <div
                            v-if="pvInverterData.pP1 && pvInverterData.pP1[device.instance]"
                            class="detail"
                        >
                            <span class="detail__label">L1</span>
                            <span class="detail__value">
                                {{ pvInverterData.pP1[device.instance].formattedValue }}
                            </span>
                            <span class="detail__value">
                                {{ pvInverterData.pV1[device.instance].formattedValue }}
                            </span>
                            <span class="detail__value">
                                {{ pvInverterData.pI1[device.instance].formattedValue }}
                            </span>
                        </div>
                        <div
                            v-if="pvInverterData.pP2 && pvInverterData.pP2[device.instance]"
                            class="detail"
                        >
                            <span class="detail__label">L2</span>
                            <span class="detail__value">
                                {{ pvInverterData.pP2[device.instance].formattedValue }}
                            </span>
                            <span class="detail__value">
                                {{ pvInverterData.pV2[device.instance].formattedValue }}
                            </span>
                            <span class="detail__value">
                                {{ pvInverterData.pI2[device.instance].formattedValue }}
                            </span>
                        </div>
                        <div
                            v-if="pvInverterData.pP3 && pvInverterData.pP3[device.instance]"
                            class="detail"
                        >
                            <span class="detail__label">L3</span>
                            <span class="detail__value">
                                {{ pvInverterData.pP3[device.instance].formattedValue }}
                            </span>
                            <span class="detail__value">
                                {{ pvInverterData.pV3[device.instance].formattedValue }}
                            </span>
                            <span class="detail__value">
                                {{ pvInverterData.pI3[device.instance].formattedValue }}
                            </span>
                        </div>
                    </div>
                </div>
                <!-- EVCS - in and out -->
                <div
                    v-if="
                        device.idDeviceType &&
                            device.idDeviceType === DEVICE_TYPES.EVCS &&
                            attrs.evChargerData.main
                    "
                    class="vrm-data-block"
                    :class="attrs.posType === 'out' ? 'ev_car_charger_out' : 'ev_car_charger_in'"
                >
                    <div class="content">
                        <div class="header header__energy_meter">
                            <div
                                v-if="ci.evgm && ci.evgm.rawValue === 1"
                                class="block-icon block-icon__blue"
                            >
                                <span class="sg-vrm-icon_149_energy_meter_16px"></span>
                            </div>
                            <div v-else class="block-icon block-icon__blue">
                                <span class="sg-vrm-icon_108_ev-charger-16px"></span>
                            </div>
                            <span>
                                {{
                                    device.customName.length > 0
                                        ? device.customName
                                        : device.productName
                                }}
                            </span>
                            <span v-if="!isMobile" class="label label--blue">
                                {{ $t('dashboard.ev_charging_station', { i18nFallback: 'EVCS' }) }}
                            </span>
                        </div>
                        <span v-if="isMobile" class="label label--blue">
                            {{ $t('dashboard.ev_charging_station', { i18nFallback: 'EVCS' }) }}
                        </span>
                        <div class="summary">
                            <div class="load" :class="attrs.evChargerData.titleClass">
                                {{ attrs.evChargerData.main }}
                            </div>
                        </div>
                        <div v-if="attrs.posType === 'in'" class="chart">
                            <HighchartsWrapper :config="charts.dashboard.ev_power_in" />
                        </div>
                        <div v-if="attrs.posType === 'out'" class="chart">
                            <HighchartsWrapper :config="charts.dashboard.ev_power_out" />
                        </div>
                    </div>
                    <div
                        v-if="attrs.posType === 'in' && chartHoverEvIn"
                        class="details graph-labels"
                    >
                        <span>{{ chartHoverEvIn.label }}</span>
                        <span>{{ chartHoverEvIn.value }}</span>
                    </div>
                    <div
                        v-if="attrs.posType === 'out' && chartHoverEvOut"
                        class="details graph-labels"
                    >
                        <span>{{ chartHoverEvOut.label }}</span>
                        <span>{{ chartHoverEvOut.value }}</span>
                    </div>

                    <div
                        v-if="
                            showDetails &&
                                attrs.evChargerData.instances &&
                                attrs.evChargerData.instances.length > 0
                        "
                        class="details details-col"
                        :class="{ 'show-all': attrs.evChargerShowAll[attrs.posType] }"
                    >
                        <div
                            v-if="
                                attrs.evChargerData.instances &&
                                    attrs.evChargerData.instances.length > 1
                            "
                        >
                            <div
                                v-for="(instance, index) in attrs.evChargerData.instances"
                                :key="`instance-${instance.name}-${index}`"
                                class="detail"
                            >
                                <span class="detail__label">{{ instance.name }}</span>
                                <span class="detail__value">{{ instance.state }}</span>
                                <span class="detail__value">{{ instance.power }}</span>
                                <span class="detail__value">{{ instance.mode }}</span>
                            </div>
                            <div
                                v-if="
                                    attrs.evChargerData.restInstances &&
                                        attrs.evChargerData.restInstances.length > 0 &&
                                        attrs.evChargerShowAll[attrs.posType]
                                "
                                class="detail"
                            >
                                <div
                                    v-for="(instance, index) in attrs.evChargerData.restInstances"
                                    :key="`restInstance-${instance.name}-${index}`"
                                >
                                    <span class="detail__label">{{ instance.name }}</span>
                                    <span class="detail__value">{{ instance.state }}</span>
                                    <span class="detail__value">{{ instance.power }}</span>
                                    <span class="detail__value">{{ instance.mode }}</span>
                                </div>
                            </div>
                            <div
                                v-if="
                                    attrs.evChargerData.restInstances &&
                                        attrs.evChargerData.restInstances.length > 0
                                "
                                class="expandable-button-style"
                            >
                                <a @click="attrs.toggleEvChargerShowAll(attrs.posType)">
                                    <span
                                        class="arrow sg-vrm-icon_051_arrow-down-16px"
                                        :class="{
                                            'rotate-arrow': attrs.evChargerShowAll[attrs.posType],
                                        }"
                                    ></span>
                                </a>
                            </div>
                        </div>
                        <div
                            v-if="
                                attrs.evChargerData.instances &&
                                    attrs.evChargerData.instances.length == 1
                            "
                        >
                            <div class="detail">
                                <span class="detail__label">
                                    {{
                                        $t('dashboard.ev_charging.status', {
                                            i18nFallback: 'Charging status',
                                        })
                                    }}
                                </span>
                                <span class="detail__value">
                                    {{ attrs.evChargerData.instances[0].state }}
                                </span>
                            </div>
                            <div class="detail">
                                <span class="detail__label">
                                    {{
                                        $t('dashboard.ev_charging.time', {
                                            i18nFallback: 'Charging time',
                                        })
                                    }}
                                </span>
                                <span class="detail__value">
                                    {{ calcTimeInterval(0, attrs.evChargerData.instances[0].time) }}
                                </span>
                            </div>
                            <div class="detail">
                                <span class="detail__label">
                                    {{ $t('dashboard.ev_charging.mode', { i18nFallback: 'Mode' }) }}
                                </span>
                                <span class="detail__value">
                                    {{ attrs.evChargerData.instances[0].mode }}
                                </span>
                            </div>
                            <div class="detail">
                                <span class="detail__label">
                                    {{
                                        $t('dashboard.ev_charging.current', {
                                            i18nFallback: 'Charge current',
                                        })
                                    }}
                                </span>
                                <span class="detail__value">
                                    {{ attrs.evChargerData.instances[0].chargeCurrent }}
                                </span>
                            </div>
                            <div class="detail">
                                <span class="detail__label">
                                    {{
                                        $t('dashboard.ev_charging.total_energy', {
                                            i18nFallback: 'Max charge current',
                                        })
                                    }}
                                </span>
                                <span class="detail__value">
                                    {{ attrs.evChargerData.instances[0].totalEnergy }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import { AngularDirective, ngInject } from '@/vue/decorators/angular-interop';
import HighchartsWrapper from '@/vue/components/shared/dashboard/HighchartsWrapper.vue';
import { DEVICE_TYPES } from '@/constants/deviceTypes';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';

@Component({
    components: {
        HighchartsWrapper,
    },
    props: {
        ci: {
            type: Object,
        },
        showDetails: {
            type: Boolean,
        },
        charts: {
            type: Object,
        },
        chartHoverPvIn: {
            type: Object,
        },
        chartHoverEvIn: {
            type: Object,
        },
        chartHoverEvOut: {
            type: Object,
        },
        chartHoverFromToGrid: {
            type: Object,
        },
        chartHoverAcMeter: {
            type: Object,
        },
        isPropertyValid: {
            type: Function,
        },
        attrs: {
            type: Object,
        },
        toggleDetails: {
            type: Function,
        },
        devices: {
            type: Array,
        },
        acMeterData: {
            type: Object,
        },
        gridMeterData: {
            type: Object,
        },
        pvInverterData: {
            type: Object,
        },
        chartHoverPvInverter: {
            type: Object,
        },
    },
})
@AngularLocaleBundle('dashboard')
@AngularDirective('alt-energy-meter-only-layout')
export default class AltEnergyMeterOnlyLayout extends Vue {
    @ngInject()
    locale;

    isMobile = window.innerWidth < 450;

    DEVICE_TYPES = DEVICE_TYPES;

    mounted() {
        window.addEventListener('resize', this.handleResize);
    }

    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
        this.isMobile = window.innerWidth < 450;
    }

    get filteredDevices() {
        const listOfDevices = this.devices.filter(device => {
            return (
                device.idDeviceType &&
                (device.idDeviceType === DEVICE_TYPES.GRID_METER ||
                    device.idDeviceType === DEVICE_TYPES.AC_METER ||
                    device.idDeviceType === DEVICE_TYPES.PV_INVERTER ||
                    device.idDeviceType === DEVICE_TYPES.EVCS)
            );
        });

        // Sort the devices based on their type to match the design order
        return listOfDevices.sort((a, b) => {
            const typeOrder = {
                [DEVICE_TYPES.GRID_METER]: 1,
                [DEVICE_TYPES.PV_INVERTER]: 2,
                [DEVICE_TYPES.AC_METER]: 3,
                [DEVICE_TYPES.EVCS]: 4,
            };
            return typeOrder[a.idDeviceType] - typeOrder[b.idDeviceType];
        });
    }

    // Filter functions used in angular
    getOnlyRawValue(value) {
        if (!value) return '';
        if (!/\d/.test(value)) return value;
        let parts = value.split(' ');
        parts.pop();
        return parts.join('');
    }

    getOnlyFormatUnit(value) {
        if (!value) return '';
        if (!/\d/.test(value)) return '';
        let parts = value.split(' ');
        return parts.pop();
    }

    calcTimeInterval(from, to) {
        if (to === undefined || to === null) {
            to = Math.floor(Date.now() / 1000);
        }

        let seconds = Math.abs(to - from);
        let minutes = Math.floor(seconds / 60);
        let hours = Math.floor(minutes / 60);
        let days = Math.floor(hours / 24);
        hours = hours - days * 24;
        minutes = minutes - days * 24 * 60 - hours * 60;
        seconds = seconds - days * 24 * 60 * 60 - hours * 60 * 60 - minutes * 60;

        const parts = [];

        if (days) parts.push(days + 'd');
        if (hours) parts.push(hours + 'h');
        if (minutes) parts.push(minutes + 'm');
        if (seconds) parts.push(seconds + 's');

        return (from > to ? '-' : '') + parts.join(', ');
    }
}
</script>
